// extracted by mini-css-extract-plugin
export default {"mailIconWrapper":"mailIconWrapper__Mjg4O","inboxNotification":"inboxNotification__ZjI2Y"};